import clsx from 'clsx';
import { Label } from '@oysterjs/ui/fieldset';
import { Switch, SwitchField } from '@oysterjs/ui/switch';

// The marks sit on the editor's white paper in both themes, so they keep their light colors.
// A blank is always marked: it holds the send until the agent fills or removes it.
const blankFieldClassName = clsx(
  '[&_[data-email-field-missing]]:rounded [&_[data-email-field-missing]]:font-semibold',
  '[&_[data-email-field-missing]]:outline-dashed [&_[data-email-field-missing]]:outline-1 [&_[data-email-field-missing]]:outline-amber-600',
  // dark-mode-exempt: on the editor's white paper.
  '[&_[data-email-field-missing]]:bg-amber-100 [&_[data-email-field-missing]]:text-amber-900'
);

const filledFieldClassName =
  '[&_[data-email-field]]:border-b-2 [&_[data-email-field]]:border-sky-500';

// my-3 matches the composer's gap between paragraphs, so the shaded block sits apart from the
// text around it the way a paragraph does.
const caraSectionClassName = clsx(
  '[&_[data-cara-section]]:my-3 [&_[data-cara-section]]:rounded-md [&_[data-cara-section]]:border-l-4 [&_[data-cara-section]]:px-2',
  // dark-mode-exempt: on the editor's white paper.
  '[&_[data-cara-section]]:border-neutral-400 [&_[data-cara-section]]:bg-neutral-100'
);

/** Classes for the body of an email drafted from a template, which mark its parts. */
export const templateHighlightClassName = (isHighlighting: boolean) =>
  clsx(blankFieldClassName, isHighlighting && [filledFieldClassName, caraSectionClassName]);

/**
 * Turns the shading of filled-in client details and Cara's text on and off. Padded like a composer
 * row (py-1.5) so it sits as far below the Email signature rule as the rows do below theirs.
 */
export const TemplateHighlightSwitch = (props: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => (
  <SwitchField className="mb-1.5 py-1.5">
    <Label className="font-normal">Highlight what Cara wrote</Label>
    <Switch color="sky" checked={props.checked} onChange={props.onChange} />
  </SwitchField>
);
